import React from "react";

import Vacancy from "../SearchResults/Vacancy";

function DescriptiveSingleJob() {
  return <Vacancy descriptive singleJobView />;
}

export default DescriptiveSingleJob;
